import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import DailyDigest from "./components/DailyDigest";
import HotBoard from "./components/HotBoard";
import Channels from "./components/Channels";
import Recap from "./components/Recap";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lift transition-colors hover:bg-primary-600 cursor-pointer"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <DailyDigest />
        <HotBoard />
        <Channels />
        <Recap />
        <Reviews />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}